<template>
  <v-card align="center" justify="center" min-width="25vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('createChannel') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-8">
      <v-form v-model="valid">
        <v-text-field prepend-icon="fa-layer-group" :label="$t('form.channelName.label')" :placeholder="$t('form.channelName.placeholder')" v-model="name" :rules="nameRules" counter="25" outlined/>
        <v-select prepend-icon="fa-shield-alt" :label="$t('form.visibility.label')" :placeholder="$t('form.visibility.placeholder')" :items="visibilities" item-text="text" item-value="value" v-model="visibility" :rules="visibilityRules" outlined/>
        <div class="d-flex align-center justify-center mb-5">
          <v-icon class="mt-n3 mr-5">fa-exclamation</v-icon>
          <p class="text-start" v-if="visibility === 'PRIVATE'" v-html="$t('byCreatingPrivateChannel')"/>
          <p class="text-start" v-else v-html="$t('byCreatingPublicChannel')"/>
        </div>
        <v-chip v-if="(visibility === 'PRIVATE' && arePrivateChannelsUnavailable) || (visibility === 'PUBLIC' && arePublicChannelsUnavailable)"
          color="accent" class="mt-n1 ml-3" text-color="black" @click="missingFeature">{{ $t('exclusiveFeature') }}
          <v-icon class="icon ml-2" color="black" x-small>fa-star</v-icon>
        </v-chip>
        <v-btn v-else :disabled="!valid" @click="createChannel">{{ $t('createChannel') }}</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';

export default {
  name: "AddChannel",
  props: {
    arePublicChannelsUnavailable: Boolean,
    arePrivateChannelsUnavailable: Boolean
  },
  data() {
    return {
      name: '',
      visibility: 'PRIVATE',
      visibilities: [
        { text: this.$t('visibilities.private'), value: 'PRIVATE'},
        { text: this.$t('visibilities.public'), value: 'PUBLIC'},
      ],

      // Rules
      valid: false,
      nameRules: [
          n => !!n || this.$t('form.channelName.rule1'),
          n => (n && n.length <= 25) || this.$t('form.channelName.rule2'),
      ],
      visibilityRules: [
          v => !!v || this.$t('form.visibility.rule'),
      ],
    };
  },
  watch: {
    name() {
      this.name = this.name.replace(' ', '_').toUpperCase();
    },
  },
  methods: {
    ...mapMutations(['setClubChannels', 'setClubPublicChannels']),
    createChannel() {
      if(this.valid) {
        if(this.validateNotExisting()) {
          alert(this.$t('alertMessage1'));
          return;
        }

        let channel = {
          name: this.name.toUpperCase(),
          club: { id: this.$store.state.clubMember.club.id },
          visibility: this.visibility,
        };

        Repository.createClubChannel(channel).then((response) => {
          if(response.status < 400) {
            alert(this.$t('alertMessage2',{name:this.name}));

            // Refresh All Channels
            Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
              if(secondResponse.status < 400)
                this.setClubChannels(secondResponse.data);
              this.close();
            });

            // Refresh Public Channels
            if(this.visibility === 'PUBLIC')
              Repository.getAllPublicClubChannels(this.$store.state.clubMember.club.id).then((secondResponse) => {
                if(secondResponse.status < 400) {
                  this.setClubPublicChannels(secondResponse.data);
                }
              });
          }
        });
      }
    },
    missingFeature() {
      let plan = this.$store.state.clubMember.club.clubPackage.name;
      if(plan == 'Swiset custom') {
        window.open("https://t.me/Swiset", '_blank');
      } else {
        this.$router.push('/subscription-plans-club')
      }
    },
    validateNotExisting() {
      return this.$store.state.clubChannels.find((channel) => channel.name === this.name) !== undefined;
    },
    close() {
      this.$emit('closeWindow');
    }
  },
}
</script>

<style scoped>

</style>



